import { apiClient } from "./apiClient";

/**
 * Inspection checklists (#212, #228).
 *
 * Everything here used to be localStorage. Templates, the per-site/hive
 * defaults, and completed runs are all account-level now, so a template
 * built at the kitchen table is there on the phone in the yard and a
 * teammate sees the same defaults.
 *
 * The builtin starters are NOT defined on this side any more. They come
 * back from listTemplates like any other row -- see
 * api/services/checklists.py, which is their one home.
 */
export const checklistsApi = {
  listTemplates: () => apiClient.get("/checklists/templates").then((r) => r.data),
  // One call for create and update: template_id present means update. The
  // page always sends the full item list, so there is no partial-edit
  // shape to model.
  saveTemplate: (payload) => apiClient.post("/checklists/templates", payload).then((r) => r.data),
  retireTemplate: (templateId) =>
    apiClient.delete(`/checklists/templates/${templateId}`).then((r) => r.data),

  listAssignments: () => apiClient.get("/checklists/assignments").then((r) => r.data),
  // target_type is what stops a site and a hive with the same number being
  // the same assignment. It is never derived client-side from a typed
  // string -- the caller knows which picker the id came from.
  assign: (targetType, targetId, templateId) =>
    apiClient
      .post("/checklists/assignments", {
        target_type: targetType,
        target_id: targetId,
        template_id: templateId,
      })
      .then((r) => r.data),
  unassign: (targetType, targetId) =>
    apiClient.delete(`/checklists/assignments/${targetType}/${targetId}`).then((r) => r.data),

  // What a given hive should open with. Its own hive default wins over one
  // set on the whole site. A null template is a normal answer, not a 404.
  defaultForHive: (hiveId) =>
    apiClient.get(`/hives/${hiveId}/checklist-default`).then((r) => r.data),

  // A completed walkthrough, item by item, notes included. Every item
  // carries its own text because the server stores a snapshot: editing the
  // template later must not rewrite this run.
  recordRun: (hiveId, payload) =>
    apiClient.post(`/hives/${hiveId}/checklist-runs`, payload).then((r) => r.data),
  listRuns: (hiveId) => apiClient.get(`/hives/${hiveId}/checklist-runs`).then((r) => r.data),
};
